import { IDirective, IScope, ITimeoutService } from 'angular';
import * as ClipboardJS from 'clipboard';
import { $Event } from '../../../helpers';
import * as tippy from 'tippy.js';
import { ToastrService } from '../../../core/services/toastr/toastr.service';

interface IGmcClipboardScope extends IScope {
  gmcClipboardSuccess: ( event: $Event<ClipboardJS.Event> ) => void;
  gmcClipboardError: ( event: $Event<ClipboardJS.Event> ) => void;
  toastrTitle: string;
}

enum TooltipActions {
  SHOW = 'show',
  HIDE = 'hide',
  DESTROY = 'destroy'
}

export function gmcClipboardDirective( $timeout: ITimeoutService, toastrService: ToastrService ): IDirective {
  return {
    restrict: 'A',
    scope: {
      toastrTitle: '=toastrTitle',
      gmcClipboardSuccess: '&',
      gmcClipboardError: '&'
    },
    link: ( scope: IGmcClipboardScope, element ) => {
      const hideDelay = 500;
      let timeoutId;
      element.attr('title', 'Copied!');
      const el = element.get(0);
      const clipboard = new ClipboardJS(el);
      // tippy(el, {
      //   arrow: true,
      //   placement: 'top',
      //   trigger: 'manual'
      // });
      //
      // const tooltipAction = ( action: TooltipActions ) => {
      //   const _tippy = (el as any)._tippy;
      //   if ( _tippy ) {
      //     _tippy[ action ]();
      //   }
      // };

      clipboard.on('success', ( event ) => {
        $timeout(() => {
          toastrService.success(`${scope.toastrTitle ? scope.toastrTitle : 'Text'} copied`);
          scope.gmcClipboardSuccess(new $Event(event));
          // tooltipAction(TooltipActions.SHOW);
          timeoutId = setTimeout(() => {
            // tooltipAction(TooltipActions.HIDE);
          }, hideDelay);
        });
      });

      clipboard.on('error', ( event ) => {
        $timeout(() => {
          scope.gmcClipboardError(new $Event(event));
        });
      });

      scope.$on('$destroy', () => {
        if ( timeoutId ) {
          clearTimeout(timeoutId);
        }
        // tooltipAction(TooltipActions.DESTROY);
        clipboard.destroy();
      });
    }
  };
}

gmcClipboardDirective.$inject = [ '$timeout', 'ToastrService' ];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-clipboard/gmc-clipboard.directive.ts